import React from 'react';
import MigrationList from './MigrationList';
export default function MigrationAnalysis() {
    return <MigrationList url={'analysis'} keyLabel="name" />
};